
import { defineComponent } from "vue";

const SimpleSelect = defineComponent({
  name: "SimpleSelect",
  inheritAttrs: false,
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: String || Number,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => {
        [{ id: 1, name: "test" }];
      },
    },
    className: {
      type: String,
      default:
        " font-medium  block w-full px-0 mt-0 bg-white rounded-lg appearance-none focus:outline-none focus:ring-0 custom-select disabled:cursor-not-allowed text-gray-500",
    },
  },
  model: {
    prop: "modelValue",
    event: "update",
  },
});
export default SimpleSelect;
